import script from "./OpenGamesDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenGamesDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OpenGamesDashboard.vue?vue&type=style&index=0&id=ab6be760&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab6be760"]])

export default __exports__